import React from "react";
import useNearViewport from "../../hooks/useNearViewport";
import { Link } from "react-router-dom";
import "./Stories.css";

const Stories: React.FC = () => {
  const { ref, isNear } = useNearViewport<HTMLElement>();
  return (
    <section ref={ref} className="stories-section" data-images-ready={isNear}>
      <div className="collage-background">
        <div className="collage-item collage-1"></div>
        <div className="collage-item collage-2"></div>
        <div className="collage-item collage-3"></div>
        <div className="collage-item collage-4"></div>
        <div className="collage-overlay"></div>
      </div>
      <div className="stories-content">
        <div className="frame-61">
          <div className="frame-65">
            <h2 className="stories-heading">The stories behind our team</h2>
            <h5 className="stories-subheading">Come work with us!</h5>
          </div>
          <div>
            <Link className="stories-button" to="/careers">
              See Openings
              <span className="arrow-up-right">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="#FAFAFA"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  aria-hidden
                >
                  <path d="M7 17L17 7M7 7h10v10" />
                </svg>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stories;
